import { signInWithGoogle } from "../../firebase/firebase.utils";
import { auth } from "../../firebase/firebase.utils";
import React, { useState } from "react";
import "./login.scss";
import { User } from "../../types/User";
import GoogleLogo from "../../assets/google.png";
import { useNavigate } from "react-router-dom";
import AngryHonker from "../../assets/honker.jpg";

const ALLOWED_USERS = [
  "mikkel_ac@hotmail.com",
  "julie.depner@gmail.com",
  "mibias.madsen@gmail.com",
];

type LoginProps = {
  onUserUpdate: (user: User | null) => void;
};

const Login: React.FC<LoginProps> = ({ onUserUpdate }) => {
  let navigate = useNavigate();
  const [user, setUser] = useState<User>();
  const [showHonker, setShowHonker] = useState<boolean>(false);

  auth.onAuthStateChanged((user: any) => {
    if (user) {
      setUser(user);
      if (ALLOWED_USERS.includes(user.email)) {
        onUserUpdate(user);
        navigate("/movies");
      } else {
        setShowHonker(true);
      }
    } else {
      setUser(undefined);
      setShowHonker(false);
    }
  });

  return (
    <div className="login-wrapper">
      <div className="user-info">
        <button onClick={signInWithGoogle} className={"icon-and-button"}>
          <img alt="google-logo" src={GoogleLogo} className={"google-logo"} />
          <div className={"button-text"}>Sign in with Google</div>
        </button>
      </div>
      {showHonker && (
        <div className={"honker-popup"}>
          <div className="honker-text">
            {`Hey, ${user?.email} - You're honking in the wrong neighborhood, buddy!`}
          </div>
          <img
            alt="website-honk-logo"
            src={AngryHonker}
            className={"honker-image"}
          />
          <button className={"sign-out-btn"} onClick={() => auth.signOut()}>
            Sign Out
          </button>
        </div>
      )}
    </div>
  );
};
export default Login;
